import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { useMemo } from "react";
export var useNumHiddenTiles = function(containerRef, tileRef, columnSpacingPixels, numTiles) {
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var numHiddenTiles = useMemo(function() {
        var _containerRef_current, _tileRef_current;
        var _containerRef_current_getBoundingClientRect;
        var _ref = (_containerRef_current_getBoundingClientRect = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.getBoundingClientRect()) !== null && _containerRef_current_getBoundingClientRect !== void 0 ? _containerRef_current_getBoundingClientRect : {}, containerWidth = _ref.width, containerHeight = _ref.height;
        var _tileRef_current_getBoundingClientRect;
        var _ref1 = (_tileRef_current_getBoundingClientRect = (_tileRef_current = tileRef.current) === null || _tileRef_current === void 0 ? void 0 : _tileRef_current.getBoundingClientRect()) !== null && _tileRef_current_getBoundingClientRect !== void 0 ? _tileRef_current_getBoundingClientRect : {}, tileWidth = _ref1.width, tileHeight = _ref1.height;
        if (containerWidth && containerHeight && tileWidth && tileHeight) {
            var tilesPerRow = Math.floor(containerWidth / (tileWidth + columnSpacingPixels));
            var numRowsVisible = Math.floor(containerHeight / tileHeight);
            return numTiles - tilesPerRow * numRowsVisible;
        }
        return undefined;
    // we need to rerun this calculation if the viewport width changes
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        viewportWidth,
        columnSpacingPixels,
        containerRef,
        tileRef,
        numTiles
    ]);
    return numHiddenTiles;
};
